import { createSlice } from '@reduxjs/toolkit';

const commonSlice = createSlice({
  name: 'common',
  initialState: {
    toaster: null,
    modal: null,
    userDetails: null,
    adModal: false,
    activeMenu: 'home'
  },
  reducers: {
    showToast: (state, param) => {
      const { payload } = param;
      state.toaster = payload;
    },
    showModal: (state, param) => {
      const { payload } = param;
      state.modal = payload;
    },
    showAdModal: (state, param) => {
      const { payload } = param;
      state.adModal = payload;
    },
    saveUserDetails: (state, param) => {
      const { payload } = param;
      state.userDetails = payload;
    },
    setActiveMenu: (state, param) => {
      const { payload } = param;
      state.activeMenu = payload;
    },
  },
});

const { actions, reducer } = commonSlice;

export const { showToast, showModal, showAdModal, saveUserDetails, setActiveMenu } = actions;
export default reducer;
